/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Control from "sap/ui/core/Control";
import { $SearchLinkSettings } from "../../controls/SearchLink";
import { Assembler } from "./Assembler";

export class TextAssembler implements Assembler<string> {
    items: Array<string> = [];

    public addText(text: string) {
        this.items.push(text);
    }

    public addImage(src: string) {
        this.items.push(" ");
    }

    public addIcon(src: string) {
        this.items.push(" ");
    }

    public addLink(props: $SearchLinkSettings) {
        if (props.icon) {
            this.items.push(" ");
        }
        this.items.push(props.text as string);
        if (props.endIcon) {
            this.items.push(" ");
        }
    }

    public addControl(control: Control) {
        throw "not supported";
    }

    public getResult(): string {
        return this.items.join("");
    }
}
